import React from "react";
import PropTypes from "prop-types";
import { useStaticQuery, graphql } from "gatsby";

import EmployeeCard from "../components/employee-card";
import CardContainer from "../components/card-container";

const ContactAnsatt = () => {
  const { allWpEmployee } = useStaticQuery(
    graphql`
      query {
        allWpEmployee(
          filter: { featuredImage: { node: { sourceUrl: { ne: null } } } }
          sort: { menuOrder: ASC }
        ) {
          edges {
            node {
              title
              content
              acfEmployee {
                email
                phone
                title
              }
              categories {
                nodes {
                  databaseId
                  name
                }
              }
              featuredImage {
                node {
                  altText
                  sourceUrl
                }
              }
            }
          }
        }
      }
    `
  );
  console.log(allWpEmployee);
  const customOrder = [
    "Malin Wiklund",
    "Pål Nilssen",
    "Simen Riisa",
    "Thomas Høiby",
    "Frode Toftøy-Andersen",
    "Aina Thorstensen Øksnevad",
    "Truls Torp Ellingsen",
    "Vegard Rake",
    "Thomas Vold Hansen",
    "Mille Pettersdatter",
    "Sara Hagen",
    "Jannicke Almenning",
    "Tor Børre Gaasland",
    "Anton Friberg",
    "Linn Chanin Sandum Næss",
    "David Denetz",
    "Julia Mattson",
    "Michelle Lanaro",
    "Jan Gabzdyl",
    "Anne Helene Hyggen",
    "Roger Rosbach",
  ];

  const sortedEmployees = [...allWpEmployee.edges].sort(
    (a, b) =>
      customOrder.indexOf(a.node.title) - customOrder.indexOf(b.node.title)
  );
  return (
    <div>
      <CardContainer
        innerStyle={{ alignItems: "flex-start", position: "relative" }}
      >
        {sortedEmployees?.map(({ node }, i) => (
          <EmployeeCard
            key={i}
            img={node.featuredImage?.node?.sourceUrl}
            name={node.title}
            jobTitle={node.acfEmployee?.title}
            tel={node.acfEmployee?.phone}
            email={node.acfEmployee?.email}
            content={node.content}
            cat={node.categories?.nodes}
          />
        ))}
      </CardContainer>
    </div>
  );
};

ContactAnsatt.propTypes = {
  data: PropTypes.object,
  post: PropTypes.object,
};

ContactAnsatt.defaultProps = {
  data: undefined,
  post: undefined,
};

export default ContactAnsatt;
